<template>
  <div>
    <v-container fluid style="margin-top:0px;margin-bottom:0px">
      <Modal
        v-if="create_access"
        :button_name="$t('Crear') + ' ' + modal_title"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service, name_filter, (current_page - 1) * $store.state.config.items_per_page)"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <!--Filter-->
      <div class="row mb-3" v-if="list_access">
        <div class="col-md-12">
          <div class="filter">
            <div class="d-flex align-items-center">
              <h4 class="title">{{ $t("Filtros") }}</h4>
              <font-awesome-icon icon="filter" />
            </div>
            <hr />
            <div class="row">
              <div class="col-md-3">
                <v-text-field data-vv-as="nombre" :label="$t('Nombre')" name="type" v-model="name_filter"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-text-field data-vv-as="contenedor" label="Número de Contenedor" name="container" v-model="container_filter"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-checkbox :label="$t('Activo')" v-model="active_filter"></v-checkbox>
              </div>

              <div class="col-md-3 d-flex align-items-center justify-content-end pr-10">
                <v-btn color="primary" dark @click="loadList(service)">{{ $t("Buscar") }}</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Filter -->

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" :label="$t('Buscar')" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" :loading-text="$t('cargando_espere')" hide-default-footer disable-pagination>
          <template v-slot:item="props">
            <tr>
              <td>
                {{ (pagination.page - 1) * pagination.itemsPerPage + props.index + 1 }}
              </td>
              <td>{{ props.item.nameWarehouse }}</td>
              <td>{{ props.item.client.nameClient }}</td>
              <td>{{ props.item.province.name }}</td>
              <td>{{ props.item.locality.name }}</td>
              <td>{{ props.item.warehouseAddress }}</td>
              <td>{{ props.item.warehouseTelephone }}</td>
              <td class="text-center">
                {{ props.item.latitudAddress != null && props.item.longitudAddress != null ? "SI" : "NO" }}
              </td>
              <td class="text-center px-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="green" class="mr-2" @click="viewStock(props.item)">
                      inventory
                    </v-icon>
                  </template>
                  <span>Ver Stock</span>
                </v-tooltip>

                <v-tooltip bottom v-if="update_access">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="editItem(props.item)">
                      edit
                    </v-icon>
                  </template>
                  <span>{{ $t("Editar") }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-1" @click="viewItem(props.item)">
                      remove_red_eye
                    </v-icon>
                  </template>
                  <span>{{ $t("Ver") }}</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning"> {{ $t("sin_resultados") + search }}". </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <div v-if="cant_pages > 1" class="text-center">
        <v-pagination
          class="mt-5 mb-5"
          v-model="current_page"
          :length="cant_pages"
          total-visible="10"
          circle
          @next="loadPage(service)"
          @previous="loadPage(service)"
          @input="loadPage(service)"
        ></v-pagination>
      </div>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
      
      <StockModal :dialog.sync="stockDialog" :warehouseId="selectedWarehouseId" :warehouseName="selectedWarehouseName" />
    </v-container>
  </div>
</template>

<script>
import { warehouseService } from "@/libs/ws/warehouseService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import Modal from "./Modal.vue";
import StockModal from "./StockModal.vue";
import RolMixin from "@/mixins/RolMixin.vue";
export default {
  components: { Modal, DialogDelete, StockModal },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      parent: this,
      service: warehouseService,
      page_title: "Warehouse",
      modal_title: "Warehouse",
      stockDialog: false,
      selectedWarehouseId: null,
      selectedWarehouseName: "",
      container_filter: "",
      mainItem: {
        id: "",
        contact: "",
        idOrganizacion: "",
        client: "",
        country: "",
        locality: "",
        province: "",
        nameWarehouse: "",
        warehouseAddress: "",
        warehouseTelephone: "",
        isActive: true,
      },
      defaultItem: null,
      headers: [
        { text: this.$t("Numero"), value: "number" },
        {
          text: this.$t("Nombre"),
          align: "left",
          sortable: true,
          value: "nameWarehouse",
        },
        {
          text: this.$t("Cliente"),
          align: "left",
          sortable: true,
          value: "client.nameClient",
        },
        {
          text: this.$t("Provincia"),
          align: "left",
          sortable: true,
          value: "province.name",
        },
        {
          text: this.$t("Localidad"),
          align: "left",
          sortable: true,
          value: "locality.name",
        },
        {
          text: this.$t("Direccion"),
          align: "left",
          sortable: true,
          value: "warehouseAddress",
        },
        {
          text: this.$t("Telefono"),
          align: "left",
          sortable: true,
          value: "warehouseTelephone",
        },
        {
          text: "Geoposicionamiento",
          align: "center",
          sortable: true,
          value: "",
        },
        { text: this.$t("Accion"), value: "enable", align: "center" },
      ],
      list: [],
    };
  },
  mounted() {
    this.defaultItem = Object.assign({}, this.mainItem);
    this.loadList(this.service);
  },
  methods: {
    deleteItemConfirm() {
      this.delete(this.service);
    },
    viewStock(item) {
      this.selectedWarehouseId = item.id;
      this.selectedWarehouseName = item.nameWarehouse;
      this.stockDialog = true;
    },
    loadList(service, name = this.name_filter, startIndex = 0, active = this.active_filter) {
      this.loading = true;
      //Controls
      service
        .filter(name, startIndex, this.$store.state.config.items_per_page, active, this.container_filter)
        .then((response) => {
          if (startIndex == 0) {
            this.current_page = 1;
          }
          this.list = response.list;
          console.log("list", this.list);
          this.cant_pages = Math.ceil(response.quantity / this.$store.state.config.items_per_page);

          if (this.selected != undefined) {
            this.selected = [];
          }

          this.loading = false;
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.loading = false;
        });
    },
  },
};
</script>
